<template>
  <div class="home">
    <div class="content">
      <div class="banner" :style="{'background-image': 'url('+picUrl+'discountCardH5/home/banner.jpg)'}"></div>
      <!-- 套餐 -->
      <div class="setMeal">
        <div class="list" v-for="item in setMeal" v-bind:key="item.pic">
          <div class="Meal-title">
            <p class="title van-ellipsis">{{ item.title }}</p>
            <p class="subTitle van-ellipsis">{{ item.subTitle }}</p>
          </div>
          <div
            class="Meal-price"
            :style="{ 'background-image': 'url(' + item.pic + ')' }"
          >
            <div class="type">{{ item.type }}</div>
            <div class="price">{{ item.price }}</div>
          </div>
        </div>
      </div>
      <div class="service-list">
        <div class="title">优惠9折起</div>
        <div class="tool">
          <div class="list">
            <img class="pic" src="../assets/home/tool00.png" />
            <p>门票</p>
          </div>
          <div class="list">
            <img class="pic" src="../assets/home/tool01.png" />
            <p>机票</p>
          </div>
          <div class="list">
            <img class="pic" src="../assets/home/tool02.png" />
            <p>酒店</p>
          </div>
          <div class="list">
            <img class="pic" src="../assets/home/tool03.png" />
            <p>加油</p>
          </div>
        </div>
      </div>
      <!-- 热门景区 -->
      <div class="hotScenic">
        <div class="hotTitle">
          <span class="txt">精选推荐</span>
        </div>
        <div class="hotContent">
          <!-- 热门景区一 -->
          <div class="scenicTop" v-if="scnicDataFrist.length">
            <div class="first">
              <div
                class="pic"
                :style="{
                  'background-image':
                    'url(' + picUrl + scnicDataFrist[0]['scenicUrl'] + ')',
                }"
              >
                <div class="tag"><span>精选</span></div>
              </div>
              <div class="text">
                <span class="name van-ellipsis">{{
                  scnicDataFrist[0].scenicName
                }}</span>
                <span class="address-distance">
                  <span class="van-ellipsis">{{
                    scnicDataFrist[0].address
                  }}</span>
                  <span class="distance" v-if="scnicDataFrist[0].distance">{{
                    distance(scnicDataFrist[0].distance)
                  }}</span>
                </span>
              </div>
            </div>
            <div class="sceond-thire">
              <div class="sceond">
                <div
                  class="pic"
                  :style="{
                    'background-image':
                      'url(' + picUrl + scnicDataFrist[1]['scenicUrl'] + ')',
                  }"
                >
                  <div class="tag"><span>精选</span></div>
                </div>
                <div class="text">
                  <span class="name van-ellipsis">{{
                    scnicDataFrist[1].scenicName
                  }}</span>
                  <span class="address-distance">
                    <span class="van-ellipsis">{{
                      scnicDataFrist[1].address
                    }}</span>
                    <span class="distance" v-if="scnicDataFrist[1].distance">{{
                      distance(scnicDataFrist[1].distance)
                    }}</span>
                  </span>
                </div>
              </div>
              <div class="thire">
                <div
                  class="pic"
                  :style="{
                    'background-image':
                      'url(' + picUrl + scnicDataFrist[2]['scenicUrl'] + ')',
                  }"
                >
                  <div class="tag"><span>精选</span></div>
                </div>
                <div class="text">
                  <span class="name van-ellipsis">{{
                    scnicDataFrist[2].scenicName
                  }}</span>
                  <span class="address-distance">
                    <span class="van-ellipsis">{{
                      scnicDataFrist[2].address
                    }}</span>
                    <span class="distance" v-if="scnicDataFrist[2].distance">{{
                      distance(scnicDataFrist[2].distance)
                    }}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- 热门景区二 -->
          <div class="hotTitle">
            <span class="txt">热门景区</span>
          </div>
          <div
            class="scenicList"
            v-for="item in scnicDataSceond"
            v-bind:key="item.scenicName"
          >
            <div
              class="pic"
              :style="{
                'background-image': 'url(' + picUrl + item['scenicUrl'] + ')',
              }"
            >
              <div class="tag">
                <span>{{ item.scenicType }}</span>
              </div>
            </div>
            <div class="text">
              <span class="name van-ellipsis">{{ item.scenicName }}</span>
              <p class="address nowrap-double">{{ item.address }}</p>
              <p class="distance" v-if="item.distance">
                {{ distance(item.distance) }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <img class="foot-logo" src="../assets/home/LOGO.png" alt />
    </div>
    <div class="footer">
      <div class="payGo" @click="payGoClick">
        <div class="name-price">
          <span class="name">
            {{ productInfo.name }}
            <template v-if="platformSwitch && price">（官方平台购卡）</template>
          </span>
          <span v-if="productInfo.price" class="price">
            <span class="icon">¥</span>
            {{ productInfo.price }}
          </span>
        </div>
        <div class="pay">立即购买</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'skinPackageOne',
	data() {
		return {
			
		}
  },
	props: {
    picUrl: String,
    price: [String, Number],
    scnicDataFrist: Array,
    scnicDataSceond: Array,
    setMeal: Array,
    productInfo: Object,
    platformSwitch: Boolean
  },
  methods: {
		payGoClick() {
			this.$emit('paylistener')
    },
    // 景区距离计算
    distance(dis) {
      let m = "";
      if (dis / 1000 >= 1) {
        m = (dis / 1000).toFixed(2) + "km";
      } else {
        m = dis + "m";
      }
      return m;
    }
	}
}
</script>
<style scoped>
html,
body,
#app {
  height: 100%;
  margin: 0;
}
.h100 {
  height: 100px;
}
.container {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #fff;
}

.content {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 300px;
  left: 0;
  width: 100%;
  height: calc(100% - 170px);
  overflow-x: hidden;
  overflow-y: scroll;
}

/* 背景图层 */
.banner {
  position: relative;
  width: 100%;
  height: 738px;
  background-size: 100% 738px;
  background-size: cover;
  overflow: hidden;
}
.banner .logo {
  position: absolute;
  top: 39px;
  left: 40px;
  z-index: 99;
  width: 248px;
  height: 48px;
  background-image: url("../assets/home/LOGO01.png");
  background-repeat: no-repeat;
  background-size: 248px 48px;
}
.banner .slogan {
  padding-top: 88px;
  text-align: center;
}
.banner .slogan img {
  width: 500px;
}
.banner .card-inner {
  position: absolute;
  bottom: -120px;
  left: 0;
  width: 100%;
}
.banner .card-inner img {
  width: 100%;
}
.banner .card-wrap {
  position: absolute;
  bottom: 0;
  left: 50%;
  margin-left: -270px;
}
.banner .card-wrap .card {
  position: relative;
  width: 540px;
}
.banner .card-wrap .card .card-pic {
  width: 100%;
}
.banner .card-wrap .card .card-icon {
  width: 180px;
  position: absolute;
  left: -90px;
  top: -110px;
}
.setMeal {
  display: flex;
  justify-content: space-between;
  margin-top: -50px;
  padding: 0 30px;
  z-index: 99;
}
.setMeal .list {
  position: relative;
  box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  width: calc(50% - 10px);
  background: #fff;
  overflow: hidden;
}
.setMeal .list .title {
  padding: 28px 20px 0 20px;
  width: calc(100% - 40px);
  font-size: 30px;
  font-weight: bold;
  color: #393833;
}
.setMeal .list .subTitle {
  padding: 7px 20px 20px 20px;
  width: calc(100% - 40px);
  font-size: 24px;
  color: #b68508;
}
.setMeal .list .Meal-price {
  display: flex;
  justify-content: space-between;
  padding: 0 30px;
  background-size: cover;
}
.setMeal .list .Meal-price .type {
  height: 112px;
  line-height: 112px;
  font-size: 28px;
  color: #393833;
}
.setMeal .list .Meal-price .price {
  height: 112px;
  line-height: 112px;
  font-size: 38px;
  color: #393833;
  font-weight: bold;
}
/* 工具栏 */
.service-list {
  padding: 0 32px;
}
.service-list .title {
  padding: 32px 0;
  font-size: 32px;
  font-weight: bold;
}
.tool {
  display: flex;
  justify-content: space-between;
  margin-bottom: 54px;
  padding: 0 30px;
  width: calc(100% - 60px);
}
.tool .list {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 28px;
}
.tool .list .pic {
  position: relative;
  width: 96px;
  height: 96px;
  margin-bottom: 20px;
}
.tool .list .pic .title {
  width: 100%;
  height: 100%;
}
.tool .list .pic .icon {
  position: absolute;
  top: 5px;
  right: -15px;
  width: 70px;
  height: 30px;
}

/* 热门景区一 */
.hotScenic {
  border-top: 20px solid #f7f7f7;
}
.hotScenic .hotTitle {
  padding: 60px 32px 16px;
  background-size: 400px 60px;
}
.hotScenic .hotTitle .txt {
  width: 100%;
  font-size: 32px;
  font-weight: bold;
}
.hotScenic .hotContent {
  padding-bottom: 30px;
}
.scenicTop {
  display: flex;
  justify-content: space-between;
  padding: 0px 30px 0 30px;
  width: calc(100% - 60px);
  height: 420px;
  font-size: 24px;
  color: #fff;
}
.scenicTop .first,
.scenicTop .sceond-thire {
  border-radius: 10px;
  width: calc(50% - 10px);
  height: 420px;
}
.scenicTop .sceond-thire {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.scenicTop .first,
.scenicTop .sceond,
.scenicTop .thire {
  position: relative;
}
.scenicTop .sceond,
.scenicTop .thire {
  width: 100%;
  height: 200px;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0));
  border-radius: 10px;
}
.scenicTop .pic {
  position: relative;
  border-radius: 10px;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}
.tag {
  position: absolute;
  left: 0;
  top: 30px;
  background-color: #ffda4d;
  color: #333;
  padding: 0 20px 0 20px;
  height: 36px;
  line-height: 36px;
}
.tag span {
  position: relative;
  display: block;
}
.tag span:after {
  content: "";
  display: block;
  position: absolute;
  right: -32px;
  top: 0px;
  border-right: 12px solid transparent;
  border-top: 18px solid #ffda4d;
  width: 0;
  height: 0;
}
.tag span:after {
  content: "";
  display: block;
  position: absolute;
  right: -32px;
  bottom: 0px;
  border-left: 12px solid transparent;
  border-bottom: 18px solid #ffda4d;
  width: 0;
  height: 0;
}
.scenicTop .name {
  position: absolute;
  bottom: 64px;
  left: 0;
  padding: 0 10px;
  width: calc(100% - 20px);
  font-size: 32px;
  font-weight: bold;
}
.scenicTop .address-distance {
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 30px;
  left: 0;
  padding: 0 10px;
  width: calc(100% - 20px);
  font-size: 20px;
}
.scenicTop .address-distance .distance {
  padding-left: 20px;
}

/* 热门景区二 */
.scenicList {
  display: flex;
  justify-content: space-between;
  box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.08);
  border-radius: 5px;
  margin: 30px auto 0 auto;
  width: calc(100% - 60px);
  height: 260px;
  font-size: 24px;
  overflow: hidden;
}
.scenicList .pic {
  position: relative;
  flex: 0 0 260px;
  width: 260px;
  height: 260px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}
.scenicList .text {
  display: flex;
  flex-direction: column;
  padding: 0 30px;
  width: calc(100% - 300px);
  height: 260px;
}
.scenicList .name {
  padding-top: 30px;
  font-size: 32px;
  font-weight: bold;
}
.scenicList .address {
  padding-top: 20px;
  height: 90rpx;
  line-height: 45px;
  font-size: 24px;
}
.scenicList .distance {
  padding-top: 20px;
  font-size: 24px;
}
/* logo */
.foot-logo {
  display: block;
  margin: 35px auto;
  width: 280px;
  height: 60px;
}
/* 底部 */
.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 100;
  padding: 20px 0 50px 0;
  width: 100%;
  height: 100px;
  background-color: #fff;
}

/* 立即购买 */
.payGo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  width: calc(100% - 60px);
  height: 100px;
  color: #333;
  background-image: url("../assets/home/payGo.png");
  background-size: 100% 100px;
  background-repeat: no-repeat;
  border-radius: 50px;
  box-shadow: 0px 10px 20px 0px rgba(255, 218, 77, 0.6);
}
.payGo .name-price {
  display: flex;
  flex-direction: column;
  padding-left: 50px;
  height: 100%;
}
.payGo .name-price .name {
  height: 40px;
  font-size: 22px;
  line-height: 40px;
  color: #fff;
}
.payGo .name-price .price {
  height: 60px;
  font-size: 40px;
  line-height: 50px;
  color: #ffc539;
}
.payGo .name-price .icon {
  font-size: 32px;
  color: #ffc539;
}
.payGo .pay {
  display: inline-block;
  padding-right: 50px;
  font-size: 36px;
  font-weight: bold;
}
.nowrap-double {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
</style>
